<template>
    <div class="container">
        <ul id="serviceProgressBar" class="serviceProgressBar" v-if="list">
          <li v-for="(item, index) in list" :key="index" :id="item.id" :value="item.key" :style="setWidth"
          :class="isStatus ? index < statusIndex ? 'previous' : index > statusIndex ? 'next' : currentStatus === 'Closed' ? 'closed' : 'active' : 'next'"
          >{{item.name}}</li>
        </ul>
    </div>
</template>
<script>
export default {
    props: {
      list: {
        type: Array,
        required: true
      },
      currentStatus: {
        type: String,
        required: true
      },      
    },
  mounted() {
    this.$nextTick(function () {
      this.moveServiceProgressBar();
    })
  },
  data() {
    return {
      length: this.list.length
    };
  },
  watch: {
    currentStatus : {        
      handler: function(newVal, oldVal) {        
        this.$forceUpdate();
      },
    }
  },
  computed: {
    statusIndex() {
      if(!this.currentStatus || -1 >= this.currentStatus ) return -1
      return this.list.findIndex(
          item => item.id === this.currentStatus
      );
    },
    isStatus() {
      console.log('this.statusIndex ',this.statusIndex)
        return -1 != this.statusIndex ? true : false;
    },
    setWidth() {
      let width = 100/this.length;         
      return { width: `${width}%` };
    },
  },
  methods: {
    moveServiceProgressBar() {
      let serviceProgressBar = window.document.getElementById("serviceProgressBar");
      if (serviceProgressBar) {
        let topNavbar = window.document.getElementById("topNavbar");
        if (topNavbar) {
          let container = window.document.createElement("div");
          container.id = "movedServiceProgressBar";
          container.style.width ="100%";
          container.style.paddingLeft = "10px";
          container.style.paddingRight = "10px";
          let topPageToolbar = window.document.getElementById("topPageToolbar");
          if (topPageToolbar) {
            topPageToolbar.parentNode.insertBefore(container, topPageToolbar);
            container.append(serviceProgressBar);
          }
        }
      }
    },
  },
};
</script>
<style scoped>
.container{
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
}
</style>
